import {Component, OnInit} from '@angular/core';
import {Subject, takeUntil} from 'rxjs';
import {UserType} from '../../../Shared/Enums/UserType';
import {Router} from '@angular/router';
import {NgxSpinnerService} from 'ngx-spinner';
import {AuthService} from '../../../Shared/Services/auth.service';
import {SharedService} from '../../../Shared/Services/shared.service';
import {InvitationsService} from "../../../Services/invitations.service";
import {GuestInvitationVm} from "../../../Model/invitations";
import {Constants} from "../../../Shared/constants";

@Component({
  selector: 'app-invitations-data',
  templateUrl: './invitations.component.html',
  styleUrl: './invitations.component.scss'
})
export class InvitationsComponent implements OnInit {
  private destroy$: Subject<boolean> = new Subject<boolean>();
  data: GuestInvitationVm[] = [];
  currentPage: number = 0;
  pageSize: number = 10;
  totalItems: number = 0;
  workshopClassifications = Constants.WorkshopClassifications;
  workshopTypes = Constants.WorkshopTypes;

  constructor(public api: InvitationsService, private auth: AuthService,
              private spinner: NgxSpinnerService, private router: Router, private shared: SharedService) {
  }

  ngOnInit() {
    if (this.auth.isAuthenticated([UserType.admin])) {
      this.spinner.show();
      this.GetAllUsers();
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  GetAllUsers() {
    this.api.list()
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: any) => {
        this.data = response;
        this.totalItems = response.length;
        this.spinner.hide();
      });
  }


  DownLoadExcelReport() {
    if (this.auth.isAuthenticated([UserType.admin])) {
      this.spinner.show();
      this.api.download()
        .pipe(takeUntil(this.destroy$))
        .subscribe((data: any) => {
          this.spinner.hide();
          this.shared.downloadBlobExcelFile(data, 'invitations');
        });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  protected readonly Constants = Constants;
}
